import * as React from "react";
import { createPortal } from "react-dom";
import { usePopperTooltip } from "react-popper-tooltip";
import cn from "classnames";

import { Button } from "ebs-design";

import { makeBEM } from "@aeo/core/utils";
import { GenericObject } from "@aeo/core/types";
import { useLayoutContainer } from "@aeo/core/hooks";

import { Badge, Flex, Icon } from "..";

export interface FiltersProps {
  queryParams?: GenericObject;
  setQueryParams?: React.Dispatch<React.SetStateAction<GenericObject>>;
}

const bem = makeBEM("filters");

export const Filters = ({
  queryParams,
  setQueryParams,
  children,
}: React.PropsWithChildren<FiltersProps>) => {
  const { getTooltipProps, setTooltipRef, setTriggerRef, visible } =
    usePopperTooltip({ trigger: "click", placement: "bottom-start" });

  const $container = useLayoutContainer();

  if (!$container) return <></>;

  const filterCount = Object.values(queryParams || {})
    .map((item) => (item instanceof Array ? item.length : item ? 1 : 0))
    .reduce((prev, c) => prev + c, 0);

  return (
    <>
      <div style={{ display: "inline-block" }} ref={setTriggerRef}>
        <Button
          className={bem("tooltip-trigger")}
          style={{ textAlign: "left" }}
          prefix={<Icon type="filter" />}
        >
          <Flex align="center" justify="space-between">
            <span>Filtre</span>
            {filterCount ? (
              <Badge size="sm" variant="fill" color="secondary" round>
                {filterCount}
              </Badge>
            ) : null}
          </Flex>
        </Button>
      </div>
      {createPortal(
        <div
          ref={setTooltipRef}
          {...getTooltipProps({
            className: bem("tooltip", { visible }),
          })}
        >
          <div className={cn("surface", bem("tooltip-content"))}>
            <section>
              <h3>Filtre</h3>
            </section>
            <section>{visible && children}</section>
            <section>
              <Flex justify="end">
                <Button
                  onClick={() =>
                    setQueryParams?.((prev) =>
                      Object.fromEntries(
                        Object.entries(prev).map((e) => [e[0], undefined]),
                      ),
                    )
                  }
                >
                  Resetează
                </Button>
              </Flex>
            </section>
          </div>
        </div>,
        $container,
      )}
    </>
  );
};
